import Header from '../components/Header';
import { useTranslation } from 'react-i18next';
import '@splidejs/react-splide/css';
import BottomNav from '../components/BottomNav';
import GalleryCarousel from '../components/GalleryCarousel';
import { useParams } from 'react-router-dom';
import { getDeputyTitleFromRouteId } from '../utils/deputy';

export default function GalleryPage() {
  const { id } = useParams();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-darkBlue flex text-white">
      <div className="flex-1 bg-darkerBlue pt-60 pb-40 pl-60 pr-40 min-w-[550px]">
        <Header />
        <div className="mt-[100px]">
          <div className="text-base text-white font-medium tracking-[2px] uppercase">
            {getDeputyTitleFromRouteId(id, t)}
          </div>
          <hr className="mt-20 mb-26 w-64" />
          <div className="text-title text-blue uppercase font-bold">
            {t('documentation')}
          </div>
          <div className="text-title text-white uppercase font-bold">
            {t('fromTimeToTime')}
          </div>
        </div>
      </div>
      <div className="flex-[2.7] py-[68px] px-96">
        <GalleryCarousel />
      </div>
      <BottomNav page={0} totalPage={1} />
    </div>
  );
}
